import { Btn, P, H1 } from "../../../AbstractElements";
import React, { Fragment, useState, useEffect } from "react";
import {
  Container,
  Col,
  Form,
  Label,
  Row,
  Card,
  CardBody,
  Input,
  Button,
} from "reactstrap";
import { useForm } from "react-hook-form";
import * as mutations from "../../../graphql/mutations";
import * as queries from "../../../graphql/queries";
import awsExports from "../../../aws-exports";
import Select from "react-select";
import AWS from "aws-sdk";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { S3_BUCKET, REGION, ASSETS, limit } from "../../../Config/Config";
import SiteDBData from "../../../Data/DistributionBoard/index";
import { generateClient } from "aws-amplify/api";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
var base64 = require("base-64");

const AddAssetsContain = (props) => {
  const navigate = useNavigate();
  const state = useLocation();

  // init AWS once
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESSKEYID,
    secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
    region: REGION,
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    e,
    ...form
  } = useForm();

  // --- State (kept same names to avoid behavioral changes)
  const [distributionBoxes, setDistributionBoxes] = useState(
    SiteDBData.getSiteDBData(),
  );
  const [distributionBoxFilter, setDistributionBoxfilter] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [formFieldData, setFormData] = useState([]);
  const [seviceGroup, setSeviceGroup] = useState([]);
  const [assetTemplate, setAssetTemplate] = useState([]);
  const [siteIdvalue, setSiteIdvalue] = useState("");
  const [siteDetails, setSiteDetails] = useState([]);
  const [seviceGroupValue, setSeviceGroupValue] = useState("");
  const [assetLocation, setAssetLocation] = useState("");
  const [address, setAddress] = useState("");
  const [Loading, setLoading] = useState(false);
  const [batteryType, setBatteryType] = useState([]);
  const [lampType, setLampType] = useState([]);
  const [fittingType, setFittingType] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [tempId, setTempId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [siteselected, setSiteselected] = useState(true);
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [assetLimit, setassetLimit] = useState(0);
  const [assetsCountOftheAO, setAssetsCountOftheAO] = useState(0);
  const [assetTemplateCount, setAssetTemplateCount] = useState("");
  const [aoId, setAoId] = useState("");
  const [maxNum, setmaxNum] = useState(0);
  const [fittingNum, setFittingNum] = useState("");
  const [fittingNumData, setFittingNumData] = useState([]);
  const [ProfilePic, setProfilePic] = useState([]);
  const [logbookData, setLogbookData] = useState([]);
  const [logbookDataSiteFilter, setLogbookDataSiteFilter] = useState([]);
  const [logbookAssetLink, setLogbookAssetLink] = useState([]);
  const [appliance, setAppliance] = useState([]);
  const LoginUserGroup = localStorage.getItem("groups");
  const [counter, setCounter] = useState(0);

  // S3 client (single instance)
  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  // --- Generic helpers

  // Generic graphql call with error logging
  const graphqlCall = async (opts) => {
    try {
      return await client.graphql(opts);
    } catch (err) {
      console.error("GraphQL error:", err);
      throw err;
    }
  };

  // Generic pagination helper: collects all pages for a list query that returns items and nextToken
  const fetchAllPages = async (
    query,
    variables = {},
    itemsPathResolver = (res) => res.data,
  ) => {
    // itemsPathResolver should extract the result wrapper (default returns data)
    let nextToken = null;
    const collected = [];
    do {
      const vars = { ...variables, ...(nextToken ? { nextToken } : {}) };
      const res = await graphqlCall({
        query,
        variables: vars,
        authMode: "API_KEY",
      });
      // attempt to find items and nextToken in common shapes
      // common patterns used: res.data.<listName>.items and .nextToken
      const data = res?.data || {};
      // find the first field that looks like a list result
      const listKey = Object.keys(data).find(
        (k) => data[k] && typeof data[k] === "object" && "items" in data[k],
      );
      if (!listKey) break;
      const listResult = data[listKey];
      if (Array.isArray(listResult.items) && listResult.items.length > 0) {
        collected.push(listResult.items);
      }
      nextToken = listResult.nextToken || null;
    } while (nextToken !== null);
    return collected.flat(1);
  };

  // Shared update/create asset count logic (preserves original behavior, localStorage updates)
  const updateOrCreateAssetCount = async (sitedetailsID) => {
    try {
      const resp = await graphqlCall({
        query: queries.assetCountsBySitedetailsID,
        variables: {
          sitedetailsID,
          limit: limit,
          filter: {
            categoriesID: { eq: state.state.category.id },
          },
        },
        authMode: "API_KEY",
      });

      const items = resp?.data?.assetCountsBySitedetailsID?.items || [];
      if (items.length > 0) {
        const updateResp = await graphqlCall({
          query: mutations.updateAssetCounts,
          variables: {
            input: {
              id: items[0].id,
              assetCount: 1 + parseInt(items[0].assetCount),
            },
          },
          authMode: "API_KEY",
        });
        if (updateResp) {
          const addedsite = await graphqlCall({
            query: queries.getAssetCounts,
            variables: { id: items[0].id, limit: 10000 },
            authMode: "API_KEY",
          });
          if (addedsite?.data?.getAssetCounts) {
            let activeAssets = [];
            if (localStorage.getItem("categoryAssetCount") !== null) {
              activeAssets = JSON.parse(
                base64.decode(localStorage.getItem("categoryAssetCount")),
              );
            }
            const existingIndex = activeAssets.findIndex(
              (item) => item.id === addedsite.data.getAssetCounts.id,
            );
            if (existingIndex > -1) {
              activeAssets[existingIndex] = addedsite.data.getAssetCounts;
            } else {
              activeAssets.push(addedsite.data.getAssetCounts);
            }
            localStorage.setItem(
              "categoryAssetCount",
              base64.encode(JSON.stringify(activeAssets)),
            );
          }
        }
      } else {
        const createResp = await graphqlCall({
          query: mutations.createAssetCounts,
          variables: {
            input: {
              assetCount: 1,
              categoriesID: state.state.category.id,
              assetownerID:
                LoginUserGroup === "site_user"
                  ? LoginUserDetails.assetOwnerId
                  : LoginUserDetails.id,
              sitedetailsID: sitedetailsID,
            },
          },
          authMode: "API_KEY",
        });
        if (createResp) {
          const promises1 = siteDetails.map(async (item) => {
            return graphqlCall({
              query: queries.assetCountsBySitedetailsID,
              variables: {
                sitedetailsID: item.id,
                limit: 10000,
              },
              authMode: "API_KEY",
            });
          });
          const results = await Promise.all(promises1);
          let assetCount = [];
          if (results.length > 0) {
            results.forEach((result1) => {
              const counts = result1.data.assetCountsBySitedetailsID;
              if (counts && counts.items && counts.items.length > 0) {
                counts.items.map((item) => {
                  assetCount.push(item);
                });
              }
            });
            localStorage.setItem(
              "categoryAssetCount",
              base64.encode(JSON.stringify(assetCount)),
            );
          }
        }
      }
    } catch (err) {
      console.error("updateOrCreateAssetCount error:", err);
    }
  };

  // digits_count (kept as in original)
  const digits_count = (n) => {
    var count = 0;
    if (n >= 1) ++count;
    while (n / 10 >= 1) {
      n /= 10;
      ++count;
    }
    return count;
  };

  // sleep helper
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // --- Data fetching functions (refactored to be concise but identical in behavior)

  const fetchAssetsData = async () => {
    try {
      const response = await graphqlCall({
        query: queries.assetsByTypeAndAssetNum,
        authMode: "API_KEY",
        variables: { type: "Assets", sortDirection: "DESC" },
      });
      let maxnumber = 0;
      let assetsDetails = response.data.assetsByTypeAndAssetNum.items;
      if (assetsDetails.length > 0) {
        maxnumber = assetsDetails[0].assetNum;
        setmaxNum(parseInt(maxnumber) + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSiteDetails = async () => {
    try {
      const result = await graphqlCall({
        query: queries.siteDetailsByAssetownerID,
        variables: { assetownerID: LoginUserDetails.id, limit },
        authMode: "API_KEY",
      });
      const sites = result.data.siteDetailsByAssetownerID.items;
      if (sites.length > 0) {
        const siteFilterArray = [];
        // preserve original (though original did JSON.parse(sites) incorrectly). Keep same behavior:
        localStorage.setItem("site", base64.encode(JSON.parse(sites)));
        let activeSites = sites.filter((item) => item.status === "Active");
        setSiteDetails(activeSites);
        activeSites.forEach((item) => siteFilterArray.push(item.id));

        try {
          const assetsResult = await graphqlCall({
            query: queries.listAssets,
            variables: { limit },
            authMode: "API_KEY",
          });
          const Assets = assetsResult.data.listAssets.items.filter((item) => {
            const _matchSites = siteFilterArray?.find(
              (id) => id === item?.siteId,
            );
            if (_matchSites) return item;
          });
          setAssetsCountOftheAO(Assets.length);
        } catch (err) {
          console.log(err);
        }
      } else {
        setAssetsCountOftheAO(0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSiteDetailsSU = async () => {
    try {
      const dataDetails = await graphqlCall({
        query: queries.linkUsersAndSitesByUserdetailsID,
        authMode: "API_KEY",
        variables: {
          userdetailsID: LoginUserDetails.id,
          filter: { status: { eq: "Active" } },
          limit,
        },
      });
      const siteDetailsArr =
        dataDetails.data.linkUsersAndSitesByUserdetailsID.items;
      if (siteDetailsArr.length > 0) {
        const siteFilterArray = [];
        siteDetailsArr.forEach((item) => {
          siteFilterArray.push({ id: { eq: item.sitedetailsID } });
        });
        const result = await graphqlCall({
          query: queries.listSiteDetails,
          variables: { limit },
          authMode: "API_KEY",
        });
        const sites = result.data.listSiteDetails.items.filter((item) => {
          const _matchSites = siteFilterArray?.find((id) => id === item?.id);
          if (_matchSites) return item;
        });
        console.log(sites);
        localStorage.setItem("site", base64.encode(JSON.parse(sites)));
        setSiteDetails(sites.filter((item) => item.status === "Active"));
      } else {
        setSiteDetails([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSubscriptionLimit = async () => {
    try {
      const result = await graphqlCall({
        query: queries.listSubscriptionLimits,
        variables: {
          filter: { subscriptionId: { eq: LoginUserDetails.paymentId } },
          limit,
        },
        authMode: "API_KEY",
      });
      let assetLimitdata = result.data.listSubscriptionLimits.items;
      setassetLimit(assetLimitdata[0].AssetLimit);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAssetTemplate = async () => {
    try {
      const result = await graphqlCall({
        query: queries.listAssetTemplates,
        variables: {
          filter: { categoriesID: { eq: state.state.category.id } },
          limit,
        },
        authMode: "API_KEY",
      });
      if (result.data.listAssetTemplates.items.length > 0) {
        const assetTemp = result.data.listAssetTemplates.items;
        setAssetTemplate(assetTemp);
        setAssetTemplateCount(assetTemp.length);
      } else {
        setAssetTemplateCount(0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchlistServiceGroup = async () => {
    try {
      const result = await graphqlCall({
        query: queries.listServiceGroups,
        variables: { limit },
        authMode: "API_KEY",
      });
      setSeviceGroup(result.data.listServiceGroups.items);
    } catch (err) {
      console.log(err);
    }
  };

  // Distribution boxes fetching (merged logic for SU and AO into single function that mirrors your original behavior)
  const fetchlistDistributionBox = async () => {
    try {
      const result = await graphqlCall({
        query: queries.siteDetailsByAssetownerID,
        variables: { assetownerID: LoginUserDetails.id, limit },
        authMode: "API_KEY",
      });
      const sites = result.data.siteDetailsByAssetownerID.items;
      if (sites.length === 0) {
        setDistributionBoxes([]);
        return;
      }
      const siteFilterArray = [];
      sites.forEach((item) => siteFilterArray.push(item.id));

      // use paginated fetch for distribution boxes
      const allBoxes = await fetchAllPages(queries.listDistributionBoxes, {
        limit,
      });
      const filtered = allBoxes.filter((item) =>
        siteFilterArray?.find((id) => id === item?.sitedetailsID),
      );
      setDistributionBoxes(filtered);
    } catch (err) {
      console.log(err);
      setDistributionBoxes([]);
    }
  };

  const fetchlistDistributionBoxSU = async () => {
    try {
      const dataDetails = await graphqlCall({
        query: queries.linkUsersAndSitesByUserdetailsID,
        authMode: "API_KEY",
        variables: {
          userdetailsID: LoginUserDetails.id,
          limit,
          filter: { status: { eq: "Active" } },
        },
      });
      const siteDetailsArr =
        dataDetails.data.linkUsersAndSitesByUserdetailsID.items;
      if (siteDetailsArr.length === 0) {
        setDistributionBoxes([]);
        return;
      }
      const siteFilterArray = siteDetailsArr.map((item) => item.sitedetailsID);
      const allBoxes = await fetchAllPages(queries.listDistributionBoxes, {
        limit,
      });
      const filtered = allBoxes.filter((item) =>
        siteFilterArray?.find((id) => id === item?.sitedetailsID),
      );
      setDistributionBoxes(filtered);
    } catch (err) {
      console.log(err);
      setDistributionBoxes([]);
    }
  };

  const fetchlistlistBatteryType = async () => {
    try {
      const result = await graphqlCall({
        query: queries.listBatteryTypes,
        variables: { limit },
        authMode: "API_KEY",
      });
      setBatteryType(result.data.listBatteryTypes.items);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchlistlistLampType = async () => {
    try {
      const result = await graphqlCall({
        query: queries.listLampTypes,
        variables: { limit },
        authMode: "API_KEY",
      });
      setLampType(result.data.listLampTypes.items);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchlistlistFittingType = async () => {
    try {
      const result = await graphqlCall({
        query: queries.listFittingTypes,
        variables: { limit },
        authMode: "API_KEY",
      });
      setFittingType(result.data.listFittingTypes.items);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchLogbooksSites = async () => {
    try {
      const allLogBooks = await fetchAllPages(queries.listLogBooks, { limit });
      setLogbookData(allLogBooks);
    } catch (err) {
      console.log(err);
      setLogbookData([]);
    }
  };

  const fetchLogbookAssetLink = async () => {
    try {
      const result = await graphqlCall({
        query: queries.listLogbookAssetLinks,
        variables: { limit },
        authMode: "API_KEY",
      });
      setLogbookAssetLink(result.data.listLogbookAssetLinks.items);
    } catch (err) {
      console.log(err);
    }
  };

  // fetch forms by id and parse formFields JSON
  async function getForms(ids) {
    try {
      const dataDetails = await graphqlCall({
        query: queries.getFormDetails,
        variables: { id: ids, limit },
        authMode: "API_KEY",
      });
      const data = dataDetails.data.getFormDetails;
      const formFieldsDetails = data?.formFields;
      if (formFieldsDetails) {
        try {
          const parsedFormData = JSON.parse(formFieldsDetails);
          setFormData(parsedFormData);
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  // --- Lifecycle
  useEffect(() => {
    setAppliance(state.state.category.categoryName);
    fetchSubscriptionLimit();
    if (localStorage.getItem("site") === null && siteDetails.length === 0) {
      LoginUserGroup === "site_user" || LoginUserGroup === "electrician"
        ? fetchSiteDetailsSU()
        : fetchSiteDetails();
    } else {
      try {
        let activeSites = JSON.parse(
          base64.decode(localStorage.getItem("site")),
        );
        setSiteDetails(activeSites.filter((item) => item.status === "Active"));
      } catch (e) {
        console.error("site localStorage parse error", e);
      }
    }
    fetchLogbookAssetLink();
    fetchlistlistBatteryType();
    fetchlistlistLampType();
    fetchlistlistFittingType();
    fetchAssetTemplate();
    fetchlistServiceGroup();
    fetchAssetsData();
    fetchLogbooksSites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- Handlers

  const selectedValue = async (e) => {
    const val = e.target.value;
    setTempId(val);

    // set template name and service group
    assetTemplate.forEach((item) => {
      if (item.id === val) {
        setTemplateName(item.templatename);
        seviceGroup.forEach((sg) => {
          if (sg.id === item.servicegroupID) {
            setSeviceGroupValue(sg.serviceName);
            getForms(item.formId);
          }
        });
      }
    });

    if (state.state && state.state.site) {
      const siteAO = siteDetails.find(
        (item) => item.id === state.state.site.id,
      );
      if (siteAO) setAoId(siteAO.assetownerID);

      const assetSiteTemp = val + "_" + state.state.site.id;

      const DBResultItems = await fetchAllPages(
        queries.assetsByAssettemplateSiteIDAndAssetNum,
        {
          assettemplateSiteID: assetSiteTemp,
          limit: 10000,
        },
      );

      if (DBResultItems.length > 0) {
        const sortedAssets = DBResultItems.sort(
          (a, b) => b.fittingNumber - a.fittingNumber,
        );
        setFittingNumData(sortedAssets);
        const latestFittingNum = sortedAssets.find(
          (item) => item.fittingNumber,
        );
        setFittingNum((prev) => {
          if (!latestFittingNum?.fittingNumber) return "1";
          const lastValue = latestFittingNum.fittingNumber;
          return isNaN(lastValue)
            ? lastValue
            : String(parseInt(lastValue, 10) + 1);
        });
      } else {
        setFittingNum(1);
        setFittingNumData(fittingNumData);
      }
    }
  };

  const siteSelect = async (event) => {
    const value = event.value;
    setSiteId(value);
    setSiteselected(true);
    setSiteIdvalue(event);

    const siteAO = siteDetails.find((item) => item.id === value);
    if (siteAO) setAoId(siteAO.assetownerID);

    const assetSiteTemp = tempId + "_" + value;

    const DBResultItems = await fetchAllPages(
      queries.assetsByAssettemplateSiteIDAndAssetNum,
      {
        assettemplateSiteID: assetSiteTemp,
        limit: 10000,
      },
    );

    if (DBResultItems.length > 0) {
      const sortedAssets = DBResultItems.sort(
        (a, b) => b.fittingNumber - a.fittingNumber,
      );
      setFittingNumData(sortedAssets);
      const latestFittingNum = sortedAssets.find((item) => item.fittingNumber);
      setFittingNum((prev) => {
        if (!latestFittingNum?.fittingNumber) return "1";
        const lastValue = latestFittingNum.fittingNumber;
        return isNaN(lastValue)
          ? lastValue
          : String(parseInt(lastValue, 10) + 1);
      });
    } else {
      setFittingNum(1);
      setFittingNumData(fittingNumData);
    }
  };

  React.useEffect(() => {
    if (siteId !== "") {
      setLogbookDataSiteFilter(
        logbookData.filter((item) => {
          return item.siteId === siteId && item.logbookName !== null;
        }),
      );
      setDistributionBoxfilter(
        distributionBoxes.filter((item) => item.sitedetailsID === siteId),
      );
    } else {
      setDistributionBoxfilter(distributionBoxes);
      setLogbookDataSiteFilter(logbookData);
    }
  }, [siteId, distributionBoxes, logbookData]);

  const cancelForm = () => {
    if (state.state.category && state.state.site) {
      navigate(`${process.env.PUBLIC_URL}/assets`, {
        state: { category: state.state.category, site: state.state.site },
      });
    } else {
      navigate(`${process.env.PUBLIC_URL}/assets`, {
        state: { category: state.state.category },
      });
    }
  };

  const onSelectFile = async (e) => {
    const file = e.target.files[0];
    const params = {
      ACL: "public-read",
      Body: file,
      Bucket: S3_BUCKET,
      Key: `public/${ASSETS}/${file.name}`,
    };
    myBucket
      .putObject(params)
      .on("httpUploadProgress", (evt) => {
        console.log(evt);
        const filedetails = [];
        filedetails.push({ fileName: file.name, type: file.type });
        setProfilePic(filedetails);
      })
      .send((err) => {
        if (err) console.log(err);
      });
  };

  React.useEffect(() => {
    if (state.state.site && counter < 500) {
      setSiteId(state.state.site.id);
      if (state.state.site.id !== "") {
        setLogbookDataSiteFilter(
          logbookData.filter((item) => {
            return (
              item.siteId === state.state.site.id && item.logbookName !== null
            );
          }),
        );
        const db = distributionBoxes.filter(
          (item) => item.sitedetailsID === state.state.site.id,
        );
        setDistributionBoxfilter(db);
      } else {
        setDistributionBoxfilter(distributionBoxes);
        setLogbookDataSiteFilter(logbookData);
      }
      setCounter((prevCounter) => prevCounter + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.state.site, distributionBoxes, logbookData]);

  const optionsSites = [
    { value: "", label: "Select Site" },
    ...siteDetails.map((item) => ({
      value: item.id,
      label:
        item.siteName +
        " " +
        "(" +
        (item.unitNumber ? item.unitNumber : "") +
        ")",
    })),
  ];

  const handleSite = (event) => {
    setSiteId(event.value);
    setSiteIdvalue(event);
  };

  // --- formInputs render
  const formInputs = Object.keys(formFieldData).map((e) => {
    const { label, type, mandatory, errorMessage, options } = formFieldData[e];

    return (
      <Col md="6 mb-3" key={e}>
        <label>{label}</label>
        {type !== "dropdown" && (
          <input
            placeholder={label}
            className="form-control"
            type={type}
            name={e}
            {...register(e, { required: mandatory })}
          />
        )}
        {type === "dropdown" && (
          <select
            className="form-control"
            name={e}
            {...register(e, { required: mandatory })}
          >
            <option value="">Choose {label}...</option>
            {options.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </select>
        )}
        <span>{errors.e && { errorMessage }}</span>
      </Col>
    );
  });

  // --- onSubmit (kept logic identical but refactored structure)
  async function onSubmit(formData) {
    console.log(appliance);
    console.log(state.state.category);
    console.log(formData);
    console.log(siteId);
    console.log(fittingNum);
    try {
      setLoading(true);
      if (siteIdvalue !== "" || (state.state && state.state.site)) {
        setSiteselected(true);
        const formValues = [];
        Object.keys(formFieldData).map((e) => {
          formValues.push({ [e]: formData[e] });
        });

        let tempSiteIdd =
          state.state && state.state.site
            ? formData.assetType + "_" + state.state.site.id
            : formData.assetType + "_" + siteId;

        try {
          const response = await graphqlCall({
            query: queries.assetsByAssettemplateSiteIDAndAssetNum,
            variables: {
              assettemplateSiteID: tempSiteIdd,
              limit: 800,
              filter: { fittingNumber: { eq: fittingNum } },
            },
            authMode: "API_KEY",
          });

          const items =
            response.data.assetsByAssettemplateSiteIDAndAssetNum.items;
          // duplicated or not, original allowed duplicate creation — we follow same behavior
          const createAssetInputBase = {
            assettemplateID: formData.assetType,
            assetOwnerID: aoId,
            assetType: templateName,
            distributionboxID: formData.distributionBox,
            formFieldValues: JSON.stringify(formValues),
            siteId:
              state.state && state.state.site ? state.state.site.id : siteId,
            sitedetailsID:
              state.state && state.state.site ? state.state.site.id : siteId,
            assetModel: formData.assetModel,
            assetDescription: formData.assetDescription,
            assetWarrantyStart: formData.assetWarrantyStart,
            assetWarrantyEnd: formData.assetWarrantyEnd,
            assetMake: formData.assetMake,
            installedOn: formData.installedOn,
            assetSerialNumber: formData.assetSerialNumber,
            fittingNumber: fittingNum,
            assetLocation: assetLocation,
            status: "Active",
            assetImage: JSON.stringify(ProfilePic),
            assetNumber: state.state.category.assetNumberPrefix + maxNum,
            logbookId: formData.logbook,
            type: "Assets",
            assetNum: maxNum,
            createdBy: LoginUserDetails.id,
            source:
              LoginUserGroup === "site_owner"
                ? "AO"
                : LoginUserGroup === "site_user"
                  ? "SU"
                  : "SP",
            assettemplateSiteID:
              state.state && state.state.site
                ? formData.assetType + "_" + state.state.site.id
                : formData.assetType + "_" + siteId,
          };

          if (items.length > 0) {
            // duplicate allowed: add duplicate tag
            createAssetInputBase.duplicate =
              "duplicate asset due to fitting number";
          }

          // create asset
          try {
            const result = await graphqlCall({
              query: mutations.createAssets,
              variables: { input: createAssetInputBase },
              authMode: "API_KEY",
            });

            // after create: update/create asset counts (preserve original logic)
            const sitedetailsIDForUpdate =
              state.state && state.state.site ? state.state.site.id : siteId;
            await updateOrCreateAssetCount(sitedetailsIDForUpdate);

            const successMsg =
              items.length > 0
                ? "Asset with a duplicate fitting number for the selected site and category has been successfully added."
                : "Successfully Added Assets.";
            toast.success(successMsg, { position: toast.POSITION.TOP_CENTER });

            const assetId = result.data.createAssets.id;
            const filteredLogbook = logbookData.filter(
              (item) => item.id === formData.logbook,
            );
            if (filteredLogbook.length > 0) {
              const AssetLogbookId = filteredLogbook[0].assetsID;
              if (AssetLogbookId == null || AssetLogbookId === "") {
                await graphqlCall({
                  query: mutations.updateLogBook,
                  variables: {
                    limit,
                    input: { id: formData.logbook, assetsID: assetId },
                  },
                  authMode: "API_KEY",
                });
              }
            }

            // mimic original behaviour: wait 7s then navigate
            await sleep(7000);
            if (state.state.category && state.state.site) {
              navigate(`${process.env.PUBLIC_URL}/assets`, {
                state: {
                  category: state.state.category,
                  site: state.state.site,
                },
              });
              setLoading(false);
            } else {
              navigate(`${process.env.PUBLIC_URL}/assets`, {
                state: { category: state.state.category },
              });
              setLoading(false);
            }
          } catch (createErr) {
            toast.error("Error While Adding Assets : " + createErr, {
              position: toast.POSITION.TOP_CENTER,
            });
            console.log(createErr);
            setLoading(false);
          }
        } catch (checkErr) {
          toast.error(
            "Fitting Number for the selected category already exsists",
            { position: toast.POSITION.TOP_CENTER },
          );
          setLoading(false);
        }
      } else {
        setSiteselected(false);
        setLoading(false);
      }
    } catch (e) {
      toast.error("Error While Adding Assets : " + e.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      setLoading(false);
    }
  }

  // Render JSX (kept identical)
  return (
    <Fragment>
      <br></br>
      <Container
        fluid={true}
        style={{ paddingLeft: "0px !important" }}
        className="p-0 project-list"
      >
        <H1>{state.state.category.categoryName}</H1>
        <Card className="custom-card">
          <CardBody>
            {assetTemplateCount !== 0 ? (
              ""
            ) : (
              <P attrPara={{ className: "h4 txt-warning" }}>
                No Asset Templates for the selected Category. Please add new
                asset template and come back for asset creation.
              </P>
            )}
            <Form
              className="needs-validation"
              noValidate=""
              onSubmit={handleSubmit(onSubmit)}
            >
              {assetsCountOftheAO !== 0 && assetsCountOftheAO >= assetLimit ? (
                <>
                  <Row>
                    <Col>
                      <div>
                        <p className="errorSubscription">
                          Sorry!.. Your Asset Limit is Exceeded, Please Upgrade
                          your Subscription
                        </p>
                      </div>
                      <br></br>
                      <Btn attrBtn={{ color: "warning", onClick: cancelForm }}>
                        Close
                      </Btn>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col md="12">
                      <Row>
                        <Col md="4 mb-3">
                          <Label>Asset Type</Label>
                          <select
                            className="form-control"
                            name="assetType"
                            {...register("assetType", { required: true })}
                            onChange={selectedValue}
                          >
                            <option value="">Select Asset Type</option>
                            {assetTemplate.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.templatename}
                              </option>
                            ))}
                          </select>
                          <span>
                            {errors.assetType && "Asset Type is required"}
                          </span>
                        </Col>

                        <Col md="4 mb-3">
                          <Label>Sites</Label>
                          {state.state && state.state.site ? (
                            <>
                              <select
                                className="form-control"
                                name="site"
                                value={siteId}
                                placeholder="Sites"
                                {...register("site", {
                                  required:
                                    state.state && state.state.site
                                      ? false
                                      : true,
                                })}
                                onChange={siteSelect}
                              >
                                <option value="">Select Sites</option>
                                {siteDetails.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {(item?.siteName || "") +
                                      " (" +
                                      (item?.unitNumber || "") +
                                      ")"}
                                  </option>
                                ))}
                              </select>
                            </>
                          ) : (
                            <>
                              <Select
                                options={optionsSites}
                                isSearchable={true}
                                value={siteIdvalue}
                                placeholder="Select Sites"
                                onChange={siteSelect}
                                name="site"
                                menuPlacement="auto"
                                menuPosition="fixed"
                              />
                              <span>{!siteselected && "Site is required"}</span>
                            </>
                          )}
                          <span>{errors.site && "Site is required"}</span>
                        </Col>
                        <Col md="4 mb-3">
                          <Label>
                            Distribution Board{" "}
                            {appliance !== "Emergency Lights" ? false : true}
                          </Label>
                          <select
                            className="form-control"
                            name="distributionBox"
                            placeholder="Distribution Board"
                            {...register("distributionBox", {
                              required:
                                appliance !== "Emergency Lights" ? false : true,
                            })}
                          >
                            <option value="">Select Distribution Board</option>
                            {distributionBoxFilter.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.distributionBoxName}
                              </option>
                            ))}
                          </select>
                          <span>
                            {errors.distributionBox &&
                              "Distribution Board is required"}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4 mb-3">
                          <Label>Fitting Number</Label>
                          <input
                            type="text"
                            className="form-control"
                            name="fittingNumber"
                            placeholder="Fitting Number"
                            value={fittingNum}
                            onChange={(e) => setFittingNum(e.target.value)}
                          />
                          {errors.fittingNumber && (
                            <span>Fitting Number is required</span>
                          )}
                        </Col>
                        <Col md="4 mb-3">
                          <Label>Asset Model</Label>
                          <input
                            className="form-control"
                            name="assetModel"
                            type="text"
                            placeholder="Asset Model"
                            {...register("assetModel", { required: false })}
                          />
                        </Col>

                        <Col md="4 mb-3">
                          <Label>Asset Description</Label>
                          <input
                            type="textarea"
                            name="assetDescription"
                            className="form-control"
                            rows="3"
                            {...register("assetDescription", {
                              required: false,
                            })}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4 mb-3">
                          <Label>Asset Warranty Start Date</Label>
                          <input
                            className="form-control"
                            name="assetWarrantyStart"
                            type="date"
                            {...register("assetWarrantyStart", {
                              required: true,
                            })}
                            onChange={(dt) => setStartDate(dt.target.value)}
                          />
                          <span>
                            {errors.assetWarrantyStart &&
                              "Asset Warranty Start Date is required"}
                          </span>
                        </Col>
                        <Col md="4 mb-3">
                          <Label>Asset Warranty End Date</Label>
                          <input
                            className="form-control"
                            name="assetWarrantyEnd"
                            min={startDate}
                            type="date"
                            {...register("assetWarrantyEnd", {
                              required: true,
                            })}
                          />
                          <span>
                            {errors.assetWarrantyEnd &&
                              "Asset Warranty End Date is required"}
                          </span>
                        </Col>
                        <Col md="4 mb-3">
                          <Label>Installed On</Label>
                          <input
                            className="form-control"
                            name="installedOn"
                            type="date"
                            {...register("installedOn", { required: true })}
                          />
                          <span>
                            {errors.installedOn && "Installed On is required"}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4 mb-3">
                          <Label>Asset Make</Label>
                          <input
                            className="form-control"
                            name="assetMake"
                            type="text"
                            placeholder="Asset Make"
                            {...register("assetMake", { required: false })}
                          />
                        </Col>
                        <Col md="4 mb-3">
                          <Label>Asset Serial Number</Label>
                          <input
                            className="form-control"
                            name="assetSerialNumber"
                            type="text"
                            placeholder="Asset Serial Number"
                            {...register("assetSerialNumber", {
                              required: false,
                            })}
                          />
                        </Col>
                        <Col md="4 mb-3">
                          <Label>Asset Location</Label>
                          <input
                            className="form-control"
                            name="assetLocation"
                            placeholder="Asset Location"
                            defaultValue={address}
                            {...register("assetLocation", { required: false })}
                            onChange={(event) =>
                              setAssetLocation(event.target.value)
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6 mb-3">
                          <Label>Choose Logbook</Label>
                          <select
                            className="form-control"
                            name="logbook"
                            placeholder="Choose Logbook"
                            {...register("logbook", { required: true })}
                          >
                            <option value="">Select Logbook</option>
                            {logbookDataSiteFilter.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.logbookName}
                              </option>
                            ))}
                          </select>
                          <span>{errors.logbook && "Logbook is required"}</span>
                        </Col>
                        <Col md="6 mb-3">
                          <Label>Image</Label>
                          <Input
                            type="file"
                            className="form-control"
                            name="profilePic"
                            onChange={onSelectFile}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12 mb-3">
                          <hr className="m-t5 m-b5"></hr>
                        </Col>
                        {formInputs}
                      </Row>
                    </Col>
                    <Col md="12" className="text-end">
                      <Btn attrBtn={{ color: "primary" }}>
                        {Loading ? "Adding..." : "Add Assets"}
                      </Btn>
                      <Btn attrBtn={{ color: "danger", onClick: cancelForm }}>
                        Cancel
                      </Btn>
                    </Col>
                  </Row>
                  <Row></Row>
                </>
              )}
            </Form>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};
export default AddAssetsContain;
